// src/routes/PackingBatchRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

// Packing Batch Components
import CreatePackingBatchPage from '../pages/packingBatch/CreatePackingBatchPage';
import PackingBatchListPage from '../pages/packingBatch/PackingBatchListPage';
import PackingBatchDetailsPage from '../pages/packingBatch/PackingBatchDetailsPage';
import PrintWaybillsPage from '../pages/packingBatch/PrintWaybillsPage';
import DispatchSingleOrderPage from '../pages/packingBatch/DispatchSingleOrderPage';
import CourierUploadFormatPage from '../pages/packingBatch/CourierUploadFormatPage';

const PackingBatchRoutes = () => {
  return (
    <Routes>
      {/* Create Packing Batch */}
      <Route 
        path="/create" 
        element={
          <PermissionRoute requiredPermission="create_packing_batch">
            <CreatePackingBatchPage />
          </PermissionRoute>
        } 
      />
      
      {/* Packing Batch List */}
      <Route 
        path="/" 
        element={
          <PermissionRoute requiredPermission="view_all_packing_batches">
            <PackingBatchListPage />
          </PermissionRoute>
        } 
      />
      
      {/* Packing Batch Details */}
      <Route 
        path="/:batchId" 
        element={
          <PermissionRoute requiredPermission="view_all_packing_batches">
            <PackingBatchDetailsPage />
          </PermissionRoute>
        } 
      />
      
      {/* Print Waybills - NEW ROUTE */}
      <Route 
        path="/waybill-print" 
        element={
          <PermissionRoute requiredPermission="view_all_packing_batches">
            <PrintWaybillsPage />
          </PermissionRoute>
        } 
      />

      {/* Dispatch Single Order */}
      <Route 
        path="/dispatch/single" 
        element={
          <PermissionRoute requiredPermission="dispatch_single_orders">
            <DispatchSingleOrderPage />
          </PermissionRoute>
        } 
      />

      {/* Courier upload format */}
      <Route 
        path="/courier-upload-format" 
        element={
          <PermissionRoute requiredPermission="view_all_packing_batches">
            <CourierUploadFormatPage />
          </PermissionRoute>
        } 
      />
    </Routes>
  );
};

export default PackingBatchRoutes;